import { combineReducers } from 'redux';

import LoginReducers from './domains/Login/LoginReducers';
import UsersReducers from './domains/Users/UsersReducers';
import UserReducers from './domains/User/UserReducers';
import ScenarioReducers from './domains/Scenario/ScenarioReducers';
import ScenariosReducers from './domains/Scenarios/ScenariosReducers';
import ExercisesReducers from './domains/Exercises/ExercisesReducers';
import ExerciseReducers from './domains/Exercise/ExerciseReducers';
import ExerciseBenchmarkReducers from './domains/ExerciseBenchmark/ExerciseBenchmarkReducers';
import ExerciseCreateReducers from './domains/ExerciseCreate/ExerciseCreateReducers';
import ExerciseWaitingRoomReducers from './domains/ExerciseWaitingRoom/ExerciseWaitingRoomReducers';
import ExerciseRunReducers from './domains/ExerciseRun/ExerciseRunReducers';
import MutualAidReducers from './domains/MutualAid/MutualAidReducers';
import DashboardReducers from './domains/ExerciseRun/DashboardReducers';
import ExerciseVariablesReducers from './domains/ExerciseRun/VariablesReducers';
import UnitViewReducers from './domains/ExerciseRun/UnitViewReducers';
import CommunicationBoxReducers from './domains/ExerciseRun/CommunicationBoxReducers';
import SocketReducers from './domains/Socket/SocketReducers';
import LoggerReducers from './domains/Logger/LoggerReducers';
import CompaniesReducers from './domains/Companies/CompaniesReducers';
import CompanyReducers from './domains/Company/CompanyReducers';
import BlackListReducers from './domains/BlackList/BlackListReducers';
import ValidateTokenReducers from './domains/ValidateToken/ValidateTokenReducers';

import { i18nReducer } from 'react-redux-i18n';

const App = combineReducers({
  login: LoginReducers,
  user: UserReducers,
  users: UsersReducers,
  scenario: ScenarioReducers,
  scenarios: ScenariosReducers,
  exercises: ExercisesReducers,
  exercise: ExerciseReducers,
  exerciseBenchmark: ExerciseBenchmarkReducers,
  exerciseCreate: ExerciseCreateReducers,
  exerciseWaitingRoom: ExerciseWaitingRoomReducers,
  exerciseRun: ExerciseRunReducers,
  mutualAid: MutualAidReducers,
  dashboard: DashboardReducers,
  exerciseVariables: ExerciseVariablesReducers,
  unitView: UnitViewReducers,
  communicationbox: CommunicationBoxReducers,
  companies: CompaniesReducers,
  company: CompanyReducers,
  blacklist: BlackListReducers,
  socket: SocketReducers,
  logger: LoggerReducers,
  validateToken: ValidateTokenReducers,
  i18n: i18nReducer,
});

export default App;
